export default {
  main: '#2A482A',
  secondary: '#9CF0F0',
  contrastingColor: '#ffffff',
  priceColor: '#2A482A',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#ffffff',
};
